import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Account } from '../models/account';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root'
})
export class ProducersService extends BaseService {
  constructor(private http: HttpClient) { super(); }

  // The API returns { id: account number, name: '<account> - <producer name>' }
  get(term: string): Observable<Account[]> {
    return this.http.get<Array<{ id: string, name: string }>>(this.getUrl(`Producers/Search/${encodeURIComponent(term)}`))
      .pipe(map(producers => producers.map(producer => new Account(producer.id, producer.name))));
  }
}
